(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-01-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('brand-sale-bar')) {
  customElements.define('brand-sale-bar', class extends HTMLElement {
    connectedCallback() {
      this.clock = this.querySelector('[data-clock]');
      this.h = this.querySelector('[data-hours]');
      this.m = this.querySelector('[data-minutes]');
      this.s = this.querySelector('[data-seconds]');
      if (this.dataset.enabled !== 'true') return;
      const raw = this.dataset.end.trim();
      this.end = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(Z|[+-]\d{2}:\d{2})$/.test(raw) ? Date.parse(raw) : NaN;
      if (!Number.isFinite(this.end)) {
        if (this.dataset.editor === 'true') {
          this.clock.hidden = false;
          this.h.textContent = '13'; this.m.textContent = '54'; this.s.textContent = '12';
          this.querySelector('[data-note]').hidden = false;
        }
        return;
      }
      this.clock.hidden = false;
      this.visibility = () => { clearTimeout(this.tick); if (!document.hidden) this.update(); };
      document.addEventListener('visibilitychange', this.visibility);
      this.update();
    }
    update() {
      clearTimeout(this.tick);
      const seconds = Math.max(0, Math.ceil((this.end - Date.now()) / 1000));
      if (!seconds) {
        this.clock.hidden = true;
        if (this.dataset.hide === 'true' && this.dataset.editor !== 'true') this.hidden = true;
        else this.querySelector('[data-message]').textContent = this.dataset.expired;
        return;
      }
      this.h.textContent = String(Math.floor(seconds / 3600)).padStart(2,'0');
      this.m.textContent = String(Math.floor(seconds / 60) % 60).padStart(2,'0');
      this.s.textContent = String(seconds % 60).padStart(2,'0');
      if (!document.hidden) this.tick = setTimeout(() => this.update(), 1000);
    }
    disconnectedCallback() {
      clearTimeout(this.tick);
      document.removeEventListener('visibilitychange', this.visibility);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-01-product-main"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('brand-product-main')) {
customElements.define('brand-product-main', class extends HTMLElement {
 connectedCallback() {
  this.abort = new AbortController(); const signal = this.abort.signal;
  const data=this.querySelector('[data-variants]'); this.variants=data?JSON.parse(data.textContent):[];
  this.gallery=this.querySelector('[data-gallery]'); this.slides=[...this.gallery.querySelectorAll('img')];
  const thumbs=this.querySelector('[data-thumbs]'); thumbs.replaceChildren();
  this.slides.forEach((img,i)=>{
   const b=document.createElement('button'); b.type='button'; b.className='pb-thumb'; b.setAttribute('aria-label','Image '+(i+1)); b.setAttribute('aria-current',String(i===0));
   const t=document.createElement('img'); t.src=img.src.replace(/width=\d+/,'width=120'); t.alt=''; t.loading='lazy'; b.append(t);
   b.addEventListener('click',()=>this.go(i),{signal}); thumbs.append(b);
  });
  this.buttons=[...thumbs.children]; this.index=0; this.querySelector('[data-nav]').hidden=this.slides.length<2;
  this.querySelector('[data-prev]').addEventListener('click',()=>this.go(Math.max(0,this.index-1)),{signal});
  this.querySelector('[data-next]').addEventListener('click',()=>this.go(Math.min(this.slides.length-1,this.index+1)),{signal});
  this.gallery.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.mark());},{passive:true,signal});
  this.gallery.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.go(Math.max(0,Math.min(this.slides.length-1,this.index+(e.key==='ArrowRight'?1:-1))));}},{signal});
  this.form=this.querySelector('[data-form]'); if(!this.form)return;
  this.plan=this.querySelector('[data-plans]');
  this.form.addEventListener('change',e=>{if(e.target.name==='id')this.selectVariant();else if(e.target.name==='selling_plan')this.price();},{signal});
  this.form.addEventListener('submit',e=>this.submit(e),{signal});
  this.selectVariant();
 }
 go(i){this.gallery.scrollTo({left:i*this.gallery.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
 mark(){this.index=Math.round(this.gallery.scrollLeft/Math.max(1,this.gallery.clientWidth));this.buttons.forEach((b,i)=>b.setAttribute('aria-current',String(i===this.index)));this.querySelector('[data-prev]').disabled=this.index===0;this.querySelector('[data-next]').disabled=this.index>=this.slides.length-1;}
 selectVariant(){
  const id=new FormData(this.form).get('id');this.variant=this.variants.find(v=>String(v.id)===String(id));
  if(this.plan){
   this.plan.replaceChildren();const v=this.variant;
   if(v&&!v.requiresPlan)this.plan.add(new Option(this.plan.dataset.once,''));
   (v?.plans||[]).forEach(p=>this.plan.add(new Option(p.name+' — '+p.price,String(p.id))));
   this.plan.disabled=!v||!v.plans.length;this.querySelector('[data-plan-wrap]').hidden=this.plan.disabled;
  }
  this.price();
 }
 price(){
  const v=this.variant;const plan=v?.plans.find(p=>String(p.id)===this.plan?.value);
  const available=!!v?.available&&(!v.requiresPlan||!!plan);
  this.querySelector('[data-submit]').disabled=!available;
  this.querySelector('[data-button-label]').textContent=available?this.dataset.button:this.dataset.sold;
  this.querySelector('[data-button-price]').textContent=available?'— '+(plan?.price||v.price):'';
  const stock=this.querySelector('[data-stock]');if(stock)stock.hidden=!available;
 }
 async submit(e){
  e.preventDefault();if(this.busy||this.querySelector('[data-submit]').disabled)return;
  this.busy=true;const button=this.querySelector('[data-submit]'),error=this.querySelector('[data-error]');button.disabled=true;error.hidden=true;
  try{
   const endpoint=this.dataset.add.replace(/\/$/,'')+'.js';
   const response=await fetch(endpoint,{method:'POST',body:new FormData(this.form),headers:{Accept:'application/json'}});
   const result=await response.json();
   if(!response.ok)throw new Error(result.description||result.message||'Unable to add this product.');
   window.location.assign(this.dataset.cart);
  }catch(err){error.textContent=err.message;error.hidden=false;this.busy=false;this.price();}
 }
 disconnectedCallback(){this.abort?.abort();cancelAnimationFrame(this.frame);}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-guarantee-risk-free"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('brand-guarantee')) {
 customElements.define('brand-guarantee',class extends HTMLElement {
  connectedCallback() {
   this.controller=new AbortController();
   this.querySelector('[data-scroll-offer]')?.addEventListener('click',event=>{
    event.preventDefault();
    const result=this.findOffer();
    const offset=Number(this.dataset.offset)||0;
    const lead=result?.buttonFallback ? Number(this.dataset.lead)||0 : 0;
    const top=result?Math.max(0,result.element.getBoundingClientRect().top+window.scrollY-offset-lead):0;
    if(result) {
     const el=result.element;
     if(!el.hasAttribute('tabindex')) {
      el.setAttribute('tabindex','-1');
      el.addEventListener('blur',()=>el.removeAttribute('tabindex'),{once:true});
     }
     el.focus({preventScroll:true});
    }
    window.scrollTo({top,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
   },{signal:this.controller.signal});
  }
  visible(el) {return !!el&&el.getClientRects().length>0&&getComputedStyle(el).visibility!=='hidden';}
  findOffer() {
   const custom=this.dataset.target.trim();
   if(custom) {
    try {const el=document.querySelector(custom);if(this.visible(el))return {element:el,buttonFallback:false};} catch(e) {}
   }
   const before=[...document.querySelectorAll('.phs-section,brand-product-main')].filter(el=>this.visible(el)&&(el.compareDocumentPosition(this)&Node.DOCUMENT_POSITION_FOLLOWING));
   const hero=before[before.length-1];
   if(hero) {
    const bundle=[...hero.querySelectorAll('[data-phs-bundle-slot],.pb-fieldset')].find(el=>this.visible(el)&&el.getBoundingClientRect().height>4);
    if(bundle)return {element:bundle,buttonFallback:false};
    const button=hero.querySelector('.phs-add-to-cart,[data-submit],button[type="submit"]');
    if(this.visible(button))return {element:button,buttonFallback:true};
   }
   const forms=[...document.querySelectorAll('form[action*="/cart/add"]')].filter(el=>this.visible(el)&&(el.compareDocumentPosition(this)&Node.DOCUMENT_POSITION_FOLLOWING));
   if(forms.length)return {element:forms[0],buttonFallback:true};
   return null;
  }
  disconnectedCallback() {this.controller?.abort();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('story-reviews')) {
  customElements.define('story-reviews', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.querySelector('.sr-track');
      if ('IntersectionObserver' in window) {
        this.imageObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.loading = 'eager';
              this.imageObserver.unobserve(entry.target);
            }
          });
        }, {rootMargin:'250px'});
        this.querySelectorAll('img[loading="lazy"]').forEach(img => this.imageObserver.observe(img));
      }
      if (!this.track) return;
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.querySelector('.sr-controls').hidden = false;
      const move = direction => {
        const card = this.track.querySelector('.sr-card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({left:direction * (card.getBoundingClientRect().width + gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      };
      this.prev.addEventListener('click', () => move(-1), {signal});
      this.next.addEventListener('click', () => move(1), {signal});
      this.track.addEventListener('scroll', () => this.scheduleUpdate(), {signal,passive:true});
      this.track.addEventListener('keydown', e => {
        if (e.target !== this.track) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();move(e.key === 'ArrowRight'?1:-1);
        }
      }, {signal});
      document.addEventListener('shopify:block:select', e => {
        const card = e.target.closest('.sr-card');
        if (card && this.contains(card)) {
          const left = card.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
          this.track.scrollTo({left,behavior:'auto'});
        }
      }, {signal});
      this.resize = new ResizeObserver(() => this.scheduleUpdate());
      this.resize.observe(this.track);
      this.scheduleUpdate();
    }
    scheduleUpdate() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        if (!this.isConnected) return;
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.imageObserver?.disconnect();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skin-transformation01"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('skin-transformations')) {
  customElements.define('skin-transformations', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.st-viewport');
      this.track = this.querySelector('.st-track');
      this.original = this.querySelector('[data-original]');
      this.toggle = this.querySelector('.st-toggle');
      if (!this.original) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false;
      this.hovered = false;
      this.focused = false;
      this.near = false;
      this.ready = false;
      this.loadingImages = false;
      this.toggle.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.toggle.setAttribute('aria-label', this.userPaused ? this.toggle.dataset.play : this.toggle.dataset.pause);
        this.toggle.querySelector('.st-pause').hidden = this.userPaused;
        this.toggle.querySelector('.st-play').hidden = !this.userPaused;
        this.updatePlayback();
      }, {signal});
      this.viewport.addEventListener('pointerenter', e => {
        if (this.dataset.hover === 'true' && e.pointerType === 'mouse') {
          this.hovered = true; this.updatePlayback();
        }
      }, {signal});
      this.viewport.addEventListener('pointerleave', () => {
        this.hovered = false; this.updatePlayback();
      }, {signal});
      this.viewport.addEventListener('focusin', () => {
        this.focused = true; this.updatePlayback();
      }, {signal});
      this.viewport.addEventListener('focusout', () => {
        this.focused = false; this.updatePlayback();
      }, {signal});
      document.addEventListener('visibilitychange', () => this.updatePlayback(), {signal});
      document.addEventListener('shopify:block:select', e => {
        if (this.contains(e.target)) { this.focused = true; this.updatePlayback(); }
      }, {signal});
      document.addEventListener('shopify:block:deselect', () => {
        this.focused = false; this.updatePlayback();
      }, {signal});
      this.reduced.addEventListener('change', () => this.rebuild(), {signal});
      this.resize = new ResizeObserver(() => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.rebuild());
      });
      this.resize.observe(this.viewport);
      this.resize.observe(this.original);
      this.observer = new IntersectionObserver(entries => {
        this.near = entries[0].isIntersecting;
        if (this.near) this.prepareImages();
        this.updatePlayback();
      }, {rootMargin:'250px'});
      this.observer.observe(this);
    }
    async prepareImages() {
      if (this.loadingImages || this.ready) return;
      this.loadingImages = true;
      const signal = this.controller.signal;
      await Promise.all([...this.original.querySelectorAll('img')].map(img => {
        img.loading = 'eager';
        return img.decode().catch(() => {});
      }));
      if (signal.aborted) return;
      this.ready = true;
      this.rebuild();
    }
    rebuild() {
      if (!this.ready || !this.isConnected) return;
      const oldDuration = this.animation?.effect.getTiming().duration;
      const progress = oldDuration ? (Number(this.animation.currentTime) % oldDuration) / oldDuration : 0;
      this.animation?.cancel();
      this.animation = null;
      this.track.querySelectorAll('[data-copy]').forEach(el => el.remove());
      this.removeAttribute('data-moving');
      this.toggle.hidden = true;
      if (this.reduced.matches) return;
      const width = this.original.getBoundingClientRect().width;
      if (!width || !this.viewport.clientWidth) return;
      const copies = Math.ceil(this.viewport.clientWidth / width);
      for (let i = 0; i < copies; i++) {
        const clone = this.original.cloneNode(true);
        clone.removeAttribute('data-original');
        clone.setAttribute('data-copy', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        clone.querySelectorAll('*').forEach(el => {
          [...el.attributes].forEach(a => {
            if (a.name === 'id' || a.name.startsWith('data-shopify')) el.removeAttribute(a.name);
          });
        });
        clone.querySelectorAll('img').forEach(img => { img.loading = 'eager'; img.alt = ''; });
        this.track.appendChild(clone);
      }
      this.viewport.scrollLeft = 0;
      const duration = width / Math.max(5, Number(this.dataset.speed) || 40) * 1000;
      const keyframes = [{transform:'translateX(0)'}, {transform:`translateX(-${width}px)`}];
      if (this.dataset.direction === 'right') keyframes.reverse();
      this.animation = this.track.animate(keyframes, {duration, iterations:Infinity, easing:'linear'});
      this.animation.currentTime = progress * duration;
      this.setAttribute('data-moving', '');
      this.toggle.hidden = false;
      this.updatePlayback();
    }
    updatePlayback() {
      if (!this.animation) return;
      if (this.userPaused || this.hovered || this.focused || !this.near || document.hidden) this.animation.pause();
      else this.animation.play();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
      this.animation?.cancel();
      cancelAnimationFrame(this.frame);
      this.track?.querySelectorAll('[data-copy]').forEach(el => el.remove());
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
